/* eslint-disable no-underscore-dangle */
// Note: this sub module uses vuex-class-component: https://github.com/michaelolof/vuex-class-component
import { createModule, action } from 'vuex-class-component'

const VuexModule = createModule({
  strict: false,
})

interface SnackObj {
  color: string | 'error' | 'success';
  text: string;
}

export class App extends VuexModule.With({ namespaced: 'app' }) {
  private _environment: string = process.env.environment

  private _showVisualDesignHelper = false

  private _snackBar: null | SnackObj = null

  /**
   * DEVELOPMENT, STAGING, PRODUCTION
   */
  get environment() {
    return this._environment
  }

  get snackBar() {
    return this._snackBar
  }

  // hardcoded for now - internationalization has not been implemented.
  get defaultLang() {
    return 'da'
  }

  // hardcoded for now - internationalization has not been implemented.
  get currentLang() {
    return 'da'
  }

  @action async displaySnackBar(snackObj: SnackObj) {
    this._snackBar = snackObj
  }

  /**
   * Flag that components can listen to and show helpers
   * e.g. background color which helps with design of layout.
   *
   * Used for front end dev.
   */
  get showVisualDesignHelp() {
    return this._showVisualDesignHelper
  }

  /**
   * @see get showVisualDesignHelp
   */
  set showVisualDesignHelp(isOn: boolean) {
    this._showVisualDesignHelper = isOn
  }
}
